import React from "react";

const ServiceOffer = () => {
  return (
    <div className="service-offer-sec-1 space">
      <div className="container">
        <div className="row gy-4">
          
          {/* Left Card */}
          <div className="col-lg-6">
            <div
              className="service-offer-wrapper mega-hover"
              style={{
                backgroundImage: "url('/img/cta/2.png')",
              }}
            >
              <div className="service-offer-box">
                <h3 className="box-title">Urbania on Rent in Pune</h3>
                <p className="box-text">
                  Book a luxury Force Urbania for family trips, corporate travel,
                  weddings, tours, and outstation journeys with complete comfort.
                </p>
                <a
                  href="/booking"
                  className="th-btn sm style2 bg-theme-3 text-title"
                >
                  Book Now <i className="fas fa-arrow-up-right"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Right Card */}
          <div className="col-lg-6">
            <div
              className="service-offer-wrapper mega-hover"
              style={{
                backgroundImage: "url('/img/cta/1.png')",
              }}
            >
              <div className="service-offer-box">
                <h3 className="box-title">Luxury Urbania for All Occasions</h3>
                <p className="box-text">
                  Spacious seating, professional drivers, on-time service,
                  and affordable pricing for local, outstation, and airport travel.
                </p>
                <a
                  href="/contact-us"
                  className="th-btn sm style2"
                >
                  Contact Us <i className="fas fa-arrow-up-right"></i>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ServiceOffer;
